// with turbolinks we need to reinit trust pilot widget so it works after redirect

document.addEventListener("turbolinks:load", function () {
    if (typeof Trustpilot !== "undefined" && Trustpilot.loadFromElement) {
        var widgets = document.querySelectorAll(".trustpilot-widget");
        widgets.forEach(function (widget) {
            Trustpilot.loadFromElement(widget, true);
        });
    }
});